import { AI_CHAT } from '@/route-names';

export const chatIdFromParam = (param) => (typeof param === 'string' && /^\d+$/.test(param) ? Number(param) : null);

export const aiChatRoute = (chatId) => ({
  name: AI_CHAT,
  params: chatId === null ? {} : { chatId: String(chatId) },
});
